/** Node alarm UI multi-select values (temperature only; no-node / no-AP are AP-only). */
export const NODE_ALERT_TYPE_VALUES = [
    "lowTemperature",
    "highTemperature",
];
export function booleansToNodeAlertTypes(r) {
    const out = [];
    if (r.allowLowTemp)
        out.push("lowTemperature");
    if (r.allowHighTemp)
        out.push("highTemperature");
    return out;
}
export function nodeAlertTypesToBooleans(types) {
    return {
        allowLowTemp: types.includes("lowTemperature"),
        allowHighTemp: types.includes("highTemperature"),
    };
}
